import {ProfileRepository} from "./profile.repository";
import {ProfileRepositoryV2} from "./profile.repository.v2";

export type {ProfileRepository} from "./profile.repository";
export {ProfileRepositoryV2} from "./profile.repository.v2";

/**
 * Factory function to create the profile repository.
 */
export const createProfileRepository = (): ProfileRepository => {
  return new ProfileRepositoryV2();
};
